import React, { FC, useEffect, useState } from "react";
import {
  Container,
} from './styles'
import { billingService } from "../../../../api";
import { useNavigate, useParams } from "react-router-dom";
import { Button, InfoBlock, ModalVariables, TopProgress, Typography } from "../../../../components";
import { useTranslation } from "react-i18next";
import { timeConverterMMDDYYHHMM } from "../../../../utils/dates";
import { icons } from "../../../../icons";
import { useUi } from "../../../../context/ui.context";





const JournalItemPage:FC = ( ) => {
  const [data, setData] = useState<any>(null);
  const [pageLoading, setPageLoading] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const {journalId} = useParams()
  const {viewAlert} = useUi()
  const [t] = useTranslation()
  const [modalType, setModalType] = useState<any>('')
  const [alertTitle, setAlertTitle] = useState<any>('')
  const [alertSubTitle, setAlertSubTitle] = useState<any>()
  const [viewModal, setViewModal] = useState<boolean>(false)
  const [activeAnimation, setActiveAnimation] = useState<boolean>(false)
  const navigate = useNavigate()
  const openModal = (modal:any) => {
      setModalType(modal)
      setViewModal(true)
      setActiveAnimation(true)
    }
    const closeModalCancel = () => {
      setViewModal(false)
      setActiveAnimation(false)
    }
    const closeModal = async (values:any) => {
      if(!journalId) return;
      setLoading(true);
      try {
        await billingService.deleteJournalItem(journalId);
        await navigate(`/billing/journal`)
      } catch (e:any) {
        if (e?.response?.data.detail) {
          viewAlert({
            severity: 'error',
            message: e.response.data.detail,
          });
        }
      } finally {
        setViewModal(false);
        setActiveAnimation(false);
        setLoading(false);
      }
    } 
  const getData = async () => {
    if(!journalId) return;
    try{
      const res = await billingService.getJournalItem(journalId)
      setData(res.data);
      setPageLoading(false);
    } catch(err:any) {

    }
  }
  useEffect(() => {
    getData()
    const interval = setInterval(() => {
      getData()
    },20000)
    return () => {
      clearInterval(interval)
    }
  },[])

  if(pageLoading) return <TopProgress loading={pageLoading}/>
  const renderData = [
    {
      title:t("CLIENT"),
      id:'1',
      value:data?.client?.display,
      href:`/clients-users/clients/${data?.client?.id}`,
    },
    {
      title:t("SOURCE"),
      id:'2',
      value:`${data?.source_info?.name} ${data?.source_amount} ${data?.source_currency}`,
    },
    {
      title:t("DESTINATION"),
      id:'3',
      value:data?.destination_info?.name,
    },
    {
      title:t("DATE"),
      id:'4',
      value:timeConverterMMDDYYHHMM(data?.date_added),
    },
    {
      title:t("INVOICE"),
      id:'5',
      value:data?.invoice ? data?.invoice : 'n/a',
      href: data?.invoice ? `/billing/invoices/${data?.invoice}` : null,
    },
    {
      title:t("USER"),
      id:'6',
      value:data?.user?.full_name || 'n/a',
      href:data?.user ? `/clients-users/users/${data?.user?.id}` : null,
    },
  ]
  return(
    <Container>
       <div style={{display:'flex', gap:'10px', alignItems:'center', justifyContent:'space-between'}}>
        <Typography variant="h3">{t("JOURNAL_DETAILS")}</Typography>
        <div style={{display:'flex', gap:'10px'}}>
          <Button
            onClick={() => {
              navigate(`/billing/journal/${journalId}/edit`)
            }}
            test_id='button-delete'
            variant='icon'
            size='display'
          >
            <img src={icons.Edit}/>
          </Button>
          <Button
            onClick={() => {
              setAlertTitle(t("JOURNAL_ENTRY"))
              openModal('delete')
            }}
            test_id='button-delete'
            variant='icon'
            size='display'
          >
            <img src={icons.DeleteIcon}/>
          </Button>
        </div>
      </div>
      <InfoBlock
        data={renderData}
      />
      <ModalVariables
        modalType={modalType}
        viewModal={viewModal}
        activeAnimation={activeAnimation}
        closeModal={closeModal}
        closeModalCancel={closeModalCancel}
        alertTitle={alertTitle}
        alertSubTitle={alertSubTitle}
        loading={loading}
        instance={data}
      />
    </Container>
  )
}

export default JournalItemPage